import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import {
    Checkbox,
    Divider,
    FormControlLabel,
    Snackbar,
} from "@material-ui/core";

import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogHeader from "../dialog/functional/DialogHeader";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";

import AutoForm from "../form/functional/AutoForm";
import { cloneDeep } from 'lodash';
import { ReflexContainer, ReflexSplitter } from 'react-reflex';
import { ReflexElement } from 'react-reflex';
import BasicCrudScreenType from './../screenTypes/functional/BasicCrudScreenType';

import { debounce } from 'lodash';
import defineConf from "../../config/defineConf";

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px",
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text,
    },
}));

function TkPopElectrodeCreateDialog(props) {
    const classes = useStyles();

    const {
        id,
        mode,
        schema,
        refresh,

        onSelectMst,
        detailList,

        title,
        formId,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onInitialized,
        onSuccess,
        onClose,

        onDialogUpdateDetail,

        appendCheckBox,

        processCode,

        detailSeletMst,

        ...others
    } = props;

    const [keepOpen, setKeepOpen] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [formData, setFormData] = useState({ size: defineConf.sizeType.SMALL });
    const [instance, setInstance] = useState();

    const [height, setHeight] = useState(0);

    const [formSchema, setFormSchema] = useState(schema);

    const [grid, setGrid] = useState();

    const [, setApi] = useState();
    const [isEmpty, setIsEmpty] = useState(false);

    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const { t } = useTranslation();

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {

        if (schema) {

            let newSchema = cloneDeep(schema);

            for (let column of newSchema.columns) {
                column.width = "80%";

                if (["workTime", "epQty"].includes(column.name)) {
                    column.hideInForm = true;
                }

            }

            setFormSchema(newSchema)

        }

    }, [schema]);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.cellEditEnding.addHandler(debounce((grid, e, d) => {
                    setDisabled(false);
                    let columnName = e.getColumn()?.name;
                    let editData = grid.getCellData(e.row, e.col);

                    if (isNaN(parseInt(editData))) {
                        grid.setCellData(e.row, e.col, e?.data)

                        nofifyWarning(
                            t("warning.formDataValidationFail", { msg: "숫자만 입력이 가능합니다." })
                        );


                    } else {
                        grid.setCellData(e.row, e.col, editData)
                    }

                    // if (columnName === "timePerUnit" && parseInt(editData) > 1440) {
                    //     grid.setCellData(e.row, e.col, e?.data)
                    //     nofifyWarning(
                    //         t("warning.formDataValidationFail", { msg: "24시간 미만의 숫자만 입력 가능합니다." })
                    //     );


                    // }

                }), 10);

            }

        })();

    }, [grid, t]);


    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    };

    const onGridInitialized = (grid) => {
        grid.selectMode = "Row"
        grid.allowSorting = false;
        grid.isReadOnly = false;

        setGrid(grid);
    };

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onCloseDialog = () => {
        setFormData({ size: defineConf.sizeType.SMALL })
        if (onClose) {
            onClose();
        }
    };

    const onCancel = () => {
        setFormData({ size: defineConf.sizeType.SMALL })
        instance.hide();

    };

    const onDialogInitialized = (instance) => {
        setInstance(instance);

        if (onInitialized) {
            onInitialized(instance);
        }
    };

    const onChange = (formData) => {

        setFormData(formData);

        setDisabled(false);
    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const refreshed = (msg) => {

        notifySuccess(msg);

        if (refresh) {

            refresh.refresh();

        }
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const nofifyWarning = (msg) => {
        console.warn(msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onApiSuccess = (result) => {

        refreshed();

        if (onSuccess) {

            setTimeout(onSuccess(result.data), 0);

        }
        if (!keepOpen) {

            instance.hide();

        }


    };

    const onApiFailure = (reason) => {

        setDisabled(false);

        notifyFailure(
            t("error.insertFailure", {
                reason: reason.response
                    ? reason.response.data
                    : JSON.stringify(reason),
            })
        );
    };

    const checkItemValidation = (schema, formData) => {
        for (const column of schema.columns) {
            let [valid, msg] = checkValidation(
                "create",
                column,
                column.validation,
                formData[column.name] || ""
            );

            if (!valid) {
                nofifyWarning(msg);
                return false;
            }
        }

        return true;
    };

    const onOk = (schema, formData) => {
        if (!checkItemValidation(schema, formData)) {
            console.error(" From Validation Failed ");

            return;
        }

        if (schema.validation) {
            let [valid, msg] = checkConditionWithMsg(
                formData,
                schema.validation
            );

            if (!valid) {
                nofifyWarning(
                    t("warning.formDataValidationFail", { msg: msg })
                );
                return;
            }
        }

        let url = `/api/TkPopProductManageDetail/electrode`;

        let apiData = { ...formData };

        let form = new FormData();

        let json = {};
        let deleted = {};

        json["grid"] = grid?.itemsSource?.items;
        json["planId"] = onSelectMst?.planId;
        for (const formItem in apiData) {
            if (apiData[formItem] !== undefined) {
                json[formItem] = apiData[formItem];
            }
        }

        form.append("deleted", JSON.stringify(deleted));
        form.append("json", JSON.stringify(json));

        setDisabled(true);

        apiClient
            .post(url, form, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));
    };

    const onCloseNotification = (e, reason) => {

        if (reason === "timeout" || !reason) {
            setNotification((notification) => {
                return { ...notification, open: false };
            });
        }
    };

    const checkKeepOpen = () => {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={() =>
                                setKeepOpen((keepOpen) => !keepOpen)
                            }
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={
                        <span className={classes.label}>
                            {t("term.keepDialogOpen")}
                        </span>
                    }
                />
                <div style={{ flexGrow: 1 }}></div>
            </>
        );
    };

    const onModifyViewUrl = (url) => {

        url += `/${onSelectMst?.orderBuyerDetailId}`

        return url;

    }

    // const onModifyViewSchema = (shcema) => {
    //     shcema?.columns?.push({
    //         default: "0",
    //         formGroup: 0,
    //         formItemType: "autocomplete",
    //         formOrder: 90,
    //         hideInForm: false,
    //         key: "",
    //         name: "workTime",
    //         nullable: "YES",
    //         required: true,
    //         type: "int(11)",
    //     })
    // }

    return (
        <>
            <Dialog
                id={id}
                moveable={moveable ? moveable : uiConf.dialogMoveable}
                resizable={resizable ? resizable : uiConf.dialogResizable}
                fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
                maxWidth="lg"
                onClose={onCloseDialog}
                onInitialized={onDialogInitialized}
                {...others}
            >
                <DialogHeader>
                    <DialogTitle style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                        {title}
                    </DialogTitle>
                </DialogHeader>

                <Divider />

                <DialogContent style={{ height: height }}>
                    <ReflexContainer orientation="vertical">
                        <ReflexElement flex={0.8}>
                            <BasicCrudScreenType
                                id={formId}
                                embededInOtherScreenType
                                headerTitle={t(
                                    "term.so"
                                )}
                                table="TkVwPopElectrodeOrderPurchaseDetail"
                                view="TkVwPopElectrodeOrderPurchaseDetail"
                                noCreate
                                noEdit
                                noDelete
                                noExcel
                                noOutputSize
                                noFilter
                                onApiInitialized={onApiInitialized}
                                onInitialized={onGridInitialized}
                                onModifyViewUrl={onModifyViewUrl}
                                onLoadData={onLoadData}
                            />
                        </ReflexElement>
                        <ReflexSplitter />
                        <ReflexElement>
                            <AutoForm
                                id={formId}
                                schema={formSchema}
                                mode="edit"
                                initialData={formData}
                                onChange={onChange}
                                style={{ marginLeft: "5%" }}
                            />
                        </ReflexElement>
                    </ReflexContainer>


                    <Snackbar
                        open={notification.open && notification.severity !== "success"}
                        autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                        onClose={onCloseNotification}
                        disableWindowBlurListener={true}
                    >
                        <Alert
                            onClose={onCloseNotification}
                            variant="filled"
                            severity={notification.severity}
                        >
                            {notification.msg}
                        </Alert>
                    </Snackbar>
                </DialogContent>

                <Divider />

                <DialogActionsOkCancel
                    // firstActionComponent={checkKeepOpen}
                    labels={[t("common.add")]}
                    buttonDisabled={[(disabled || isEmpty), false]}
                    onOk={() => onOk(formSchema, formData)}
                    onCancel={onCancel}
                ></DialogActionsOkCancel>
            </Dialog>
        </>
    );
}

export default TkPopElectrodeCreateDialog;
